import { render } from "./WidgetBmfwfLinkverwaltung.vue?vue&type=template&id=50595fed&scoped=true&ts=true"
import script from "./WidgetBmfwfLinkverwaltung.vue?vue&type=script&lang=ts"
export * from "./WidgetBmfwfLinkverwaltung.vue?vue&type=script&lang=ts"

import "./WidgetBmfwfLinkverwaltung.vue?vue&type=style&index=0&id=50595fed&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50595fed"]])

export default __exports__